import logo from '../../assets/img/brand/logo.png';
import React from 'react';
import styled from 'styled-components';


function PoweredByFocalFooter(props) {
  if (props.photographer && props.photographer.activeSubscription === undefined) {
    return (
      <FocalFooter>
        <Button href={'https://app.bookfocal.com/marketplace'}>
          <P>Powered by</P>
          <Img alt="power by focal footer image" src={logo} />
        </Button>
      </FocalFooter>
    )
  } else {
    return null
  }
}

export default PoweredByFocalFooter

const FocalFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2em 0 5em 0;
`

const P = styled.p`
  text-align: justify;
  font-weight: 450;
  font-size: 0.7rem;
  color: #525f7f;
  opacity: 60%;
  padding-bottom: 0.4rem;
`

const Img = styled.img`
  width: 5em;
`

const Button = styled.a`
  position: relative;
  letter-spacing: 0.5px;
  font-size: 1.4em;
  font-weight: 600;
  margin: 0;
  color: #fbfbf2;
  display: inline-flex;
  height: 3em;
  padding: 0;
  text-transform: none;
  outline: none;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  border-radius: 1em;
  padding: 0.5em;
  margin: 1.5rem 0 0.5rem 0;
`